import { render } from "./ExpiryDate.vue?vue&type=template&id=4e5f10d1&lang=pug"
import script from "./ExpiryDate.vue?vue&type=script&lang=js"
export * from "./ExpiryDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__